import { uiActionTypes as ui } from './uiActionTypes';

export const actionTypes = {
	ui
};
